<template>
	<div>
		<v-row>
			<v-col>
				<v-card>
					<v-card-title class="d-flex align-center mb-4">
						<v-icon
							icon="$store"
							start
						/>
						<translate>Point of sale</translate>
						<v-spacer />
						<v-btn
							color="primary"
							variant="flat"
							prepend-icon="$plus"
							:href="createEndPoint"
						>
							<translate>Add Point of Sale</translate>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-row>
							<v-col>
								<v-select
									v-if="organizations"
									v-model="organizationFilter"
									:items="organizations"
									:label="`${$gettext('Organization')} ${$gettext('filter')}`"
									clearable
									variant="outlined"
								/>
							</v-col>
							<v-col>
								<v-select
									v-if="resellers"
									v-model="resellerFilter"
									:items="resellers"
									:label="`${$gettext('Reseller')} ${$gettext('filter')}`"
									clearable
									variant="outlined"
								/>
							</v-col>
							<v-col>
								<v-select
									v-if="types"
									v-model="typeFilter"
									:items="types"
									:label="`${$gettext('Type')} ${$gettext('filter')}`"
									clearable
									variant="outlined"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-text-field
									v-model="search"
									append-inner-icon="$search"
									:label="$gettext('Search')"
									single-line
									hide-details
									variant="outlined"
								/>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<model-table
									ref="pointofsalestable"
									:headers="headers"
									:search="search"
									:items-per-page="-1"
									:filter="customFilter"
									:endpoint="`/api/pointofsales?reseller_id=${resellerId}`"
									@items-retrieved="getFilterData($event)"
								>
									<template #item.name="{ item }">
										<a :href="createEndPoint + `?id=${item.id}`">
											{{ item.name }}
										</a>
									</template>
								</model-table>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import ModelTable from '../molecules/ModelTable.vue';

export default {
	name: 'PointOfSaleOverview',
	components: {
		ModelTable
	},

	props: {
		resellerId: {
			type: [Number, String, ],
			required: false,
			default: ''
		},
	},

	data () {
		return {
			search: '',
			organizations: [],
			organizationFilter: '',
			resellerFilter: '',
			resellers: [],
			typeFilter: '',
			types: [],
			createEndPoint: window.location.href + '/view',
		};
	},

	computed: {
		/**
		 * Has filters for Organizations, Resellers and Types
		 *
		 * @returns {Array} The array of headers
		 */
		headers () {
			return [
				{
					title: this.$gettext('Name'), sortable: true, key: 'name', filterable: true
				},
				{
					title: this.$gettext('Organization'), sortable: true, key: 'organization.name', filterable: true,
				},
				{
					title: this.$gettext('Reseller'), sortable: true, key: 'reseller.name', filterable: true,
				},
				{
					title: this.$gettext('Type'), sortable: true, key: 'pointofsaletype.name', filterable: true,
				},
			];
		},
	},

	watch: {
		typeFilter () {
			this.$refs.pointofsalestable.index();
		},

		resellerFilter () {
			this.$refs.pointofsalestable.index();
		},

		organizationFilter () {
			this.$refs.pointofsalestable.index();
		}
	},

	methods: {
		/**
		 * Get data from the model table component and set our selects to have the unique set for each column
		 *
		 * @param {Array} e Array of objects from event containing the data fetched from the table
		 */
		getFilterData (e) {
			this.organizations = [...new Set(e.map((item) => item.organization ? item.organization.name : '')), ].filter((f) => f);
			this.resellers = [...new Set(e.map((item) => item.reseller.name)), ];
			this.types = [...new Set(e.map((item) => item.pointofsaletype.name)), ];
		},

		/**
		 *
		 * @param {object} item
		 * @returns {boolean}
		 */
		customFilter (item) {
			if (this.typeFilter && item.pointofsaletype.name !== this.typeFilter) {
				return false;
			}
			if (this.resellerFilter && item.reseller.name !== this.resellerFilter) {
				return false;
			}
			return !this.organizationFilter || item.organization.name === this.organizationFilter;
		}
	}
};
</script>
